import fetch from "@/utils/request";


export default {
  getFundsRecord(data?: object, config = {}): any {
    return fetch({
      url: "/php/api/funds/record_list",
      method: "get",
      data,
      ...config
    });
  },

  getFundsRecordDetail(data?: object): any {
    return fetch({
      url: "/php/api/funds/record_detail",
      method: "get",
      data
    });
  },

  getAccountBalance(data?: object, config = {}): any {
    return fetch({
      url: "/php/api/account/balance",
      method: "get",
      data,
      ...config
    });
  },

  getAccountBalanceDetails(data?: object, config = {}): any {
    return fetch({
      url: "/php/api/account/balance/details",
      method: "get",
      data,
      ...config
    });
  },

  getUserExchange(data?: object, config = {}): any {
    return fetch({
      url: "/php/api/user/exchange",
      method: "get",
      data,
      ...config
    });
  },

  //资金划转记录列表
  transferList(data?: object, config = {}): any {
    return fetch({
      url: "/php/api/transfer/list",
      method: "get",
      data,
      ...config
    });
  },
  // 取消划转记录
  transferCancel(data?: object): any {
    return fetch({
      url: "/php/api/transfer/cancel",
      method: "post",
      data
    });
  },
  
  getAccountLists(data?: object): any {
    return fetch({
      url: "/php/api/account/accountLists",
      method: "post",
      data
    });
  },
  
  getFundsCancel(data?: object): any {
    return fetch({
      url: "/php/api/funds/cancel",
      method: "post",
      data
    });
  },
  
  getRechargeCancel(data?: object): any {
    return fetch({
      url: "/php/api/recharge/cancel",
      method: "post",
      data
    });
  }
  
  
  
  
  
};
